import React from 'react';
import { Popover } from '@b-design/fusion';
import QRCode from 'qrcode.react';
import $i18n from '@/i18n';

import './index.less';

interface Props {
  url: string;
}

const QRCodes: React.FC<Props> = ({ url }) => {
  
  const trigger = (
    <span>
      <span className="superapp_iconfont QRCode-tip-icon">&#xe66f;</span>
      <span className="QRCode-test">
        {$i18n.get({
          id: 'aopf.pages.miniapp.version.tabs.release.Temporary.Testing',
          dm: '临时测试二维码',
        })}
      </span>
    </span>
  );
  return (
    <div className="QRCode-container">
      <span className="title-QRCode-tip">
        <Popover align="r" v2 trigger={trigger} closable={false}>
          <div className="QRCode-popover">
            <QRCode value={`${url}&lang=${$i18n.language}`} size={154} fgColor="#000" />
            <div className="QRCode-valid">
              {$i18n.get({
                id: 'aopf.pages.miniapp.version.tabs.release.code.des',
                dm: '请使用',
              })}
              <span className="QRCode-app">
                {$i18n.get({
                  id: 'aopf.pages.miniapp.version.tabs.release.code.target',
                  dm: '目标应用程序',
                })}
              </span>
              {$i18n.get({
                id: 'aopf.pages.miniapp.version.tabs.release.code.des.two',
                dm: '扫描此二维码，以预览和测试您的小程序。',
              })}
            </div>
          </div>
        </Popover>
      </span>
    </div>
  );
};
export default QRCodes;
